import { render, staticRenderFns } from "./transactions-report-filter-dedicated.vue?vue&type=template&id=72ad0a9c"
import script from "./transactions-report-filter-dedicated.vue?vue&type=script&lang=js"
export * from "./transactions-report-filter-dedicated.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports